import { AxiosGet, AxiosPut } from "../useApi";

const route = 'routing-profiles';

export function GetAllRoutingProfiles(params) {
    return AxiosGet('all-routing-profiles', params)
}
export function GetRoutingProfiles(params) {
    return AxiosGet(route, params)
}

export function GetRoutingProfileById(params) {
    return AxiosGet(`${route}/by-id`, params)
}

export function UpdateRoutingProfile(params, data) {
    return AxiosPut(`${route}/update/name`, params, data)
}